import { extendObservable, runInAction } from 'mobx';

import { ProductsController } from '../../../networking/controllers/ProductsController';
import { Logger } from '../../../helpers/Logger';

class RelatedProductsStoreClass {
  constructor() {
    extendObservable(this, {
      relatedProducts: null,
      accessories: null,
    });
    this.productId = null;
  }

  async _fetchRelatedProducts(id) {
    try {
      const products = await ProductsController.findRelated(id);
      runInAction(() => {
        this.relatedProducts = products;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }

  async _fetchProductAccessories(id) {
    try {
      const products = await ProductsController.findAccessories(id);
      runInAction(() => {
        this.accessories = products;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }

  fetchRelatedAndAccessories(id) {
    if (this.productId && this.productId !== id) {
      runInAction(() => {
        this.relatedProducts = null;
        this.accessories = null;
      });
    }
    this.productId = id;
    this._fetchProductAccessories(id);
    this._fetchRelatedProducts(id);
  }
}

export const RelatedProductsStore = new RelatedProductsStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-detail/stores/RelatedProductsStore.js